export default "__VITE_ASSET__9117d5eb__"